<template>
  <div v-if="selectedObj" class="deco-props-bar">
    <!-- レイヤー操作 -->
    <button class="props-btn" @click="canvasStore.moveUp(selectedObj.id)" title="前面へ">
      <span class="props-icon">↑</span>
      <span class="props-label">前面</span>
    </button>
    <button class="props-btn" @click="canvasStore.moveDown(selectedObj.id)" title="背面へ">
      <span class="props-icon">↓</span>
      <span class="props-label">背面</span>
    </button>

    <!-- 中央寄せ (フレーム以外, lockPosition 時は不可) -->
    <template v-if="selectedObj.objectType !== 'frame' && selectedObj.lockPosition !== true">
      <button class="props-btn" @click="canvasStore.centerH(selectedObj.id)" title="左右中央">
        <span class="props-icon">⇔</span>
        <span class="props-label">左右中央</span>
      </button>
      <button class="props-btn" @click="canvasStore.centerV(selectedObj.id)" title="上下中央">
        <span class="props-icon">⇕</span>
        <span class="props-label">上下中央</span>
      </button>
    </template>

    <!-- テキスト専用コントロール (lockContent 時は何も編集できないので非表示) -->
    <template v-if="selectedObj.objectType === 'text' && selectedObj.lockContent !== true">
      <button class="props-btn" @click="onReedit">
        <span class="props-icon">✏️</span>
        <span class="props-label">再編集</span>
      </button>
    </template>

    <!-- 削除 (固定オブジェクトは削除不可) -->
    <button v-if="!canvasStore.selectedIsFixed" class="props-btn props-btn--delete" @click="canvasStore.removeObject(selectedObj.id)">
      <span class="props-icon">✕</span>
      <span class="props-label">削除</span>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useCanvasStore } from '../../stores/useCanvasStore'
import { useTextStore } from '../../stores/useTextStore'
import { useUiStore } from '../../stores/useUiStore'

const canvasStore = useCanvasStore()
const textStore = useTextStore()
const uiStore = useUiStore()

const selectedObj = computed(() => canvasStore.selectedObject)

function onReedit() {
  if (!selectedObj.value) return
  textStore.openEdit(selectedObj.value)
  uiStore.showPanel('text')
}

function updateColor(e) {
  canvasStore.updateObject(selectedObj.value.id, { color: e.target.value })
}

function adjustFontSize(delta) {
  const current = selectedObj.value?.fontSize ?? 40
  const newSize = Math.max(8, Math.min(2000, current + delta))
  canvasStore.updateObject(selectedObj.value.id, { fontSize: newSize })
}
</script>
